import React from 'react';

export default function SkeletonChart({ height = '200px', width = '100%', rounded = 'rounded-xl', className = '' }) {
  return (
    <div
      className={`skeleton-shimmer ${rounded} ${className} relative overflow-hidden`}
      style={{ width, height }}
      aria-hidden="true"
    >
      {/* Decorative bars to hint at chart content */}
      <div className="absolute bottom-0 left-0 right-0 flex items-end gap-1 px-4 pb-4 opacity-20">
        {[40, 65, 50, 80, 55, 70, 45, 75, 60, 85]?.map((h, i) => (
          <div
            key={i}
            className="flex-1 rounded-t"
            style={{ height: `${h}%`, background: 'var(--color-muted-foreground)' }}
          />
        ))}
      </div>
    </div>
  );
}
